import { NgModule } from "@angular/core";
import { SsgTabsetComponent, SsgTabComponent } from "./tabset.component";
import { CommonModule } from "@angular/common";
import { TranslateLoader, TranslateModule } from "@ngx-translate/core";
import { TranslateLanguageLoader } from "projects/sepidz-web-framework/src/lib/services/app-translation.service";
const SSG_TABSET_COMPONENTS = [SsgTabsetComponent, SsgTabComponent];
@NgModule({
  imports: [
    CommonModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useClass: TranslateLanguageLoader,
      },
    }),
  ],
  providers: [],
  declarations: [...SSG_TABSET_COMPONENTS],
  exports: [...SSG_TABSET_COMPONENTS],
})
export class SsgTabsetModule {}
